/**
 * @param data {GoogleSheetFormData}
 *
 * @returns {Promise<void>}
 */
module.exports = async function submitFormToGoogleSheets(data) {
    if (window.location.host === "localhost") {
        return;
    }

    const fieldMap = {
        'JSON Payload': 'entry.772051173',
        Email: 'entry.397592922',
        FirstName: 'entry.1384928759',
        LastName: 'entry.639036874',
        Company: 'entry.1882567329',
        Company_Size_Range__c: 'entry.1531527308',
        Country: 'entry.519002087',
        State: 'entry.269508666',
        marketingConsent: 'entry.1459341422',
        URL: 'entry.1625656675',
        _mktoReferrer: 'entry.589344742',
        formVid: 'entry.671691027',
        munchkinId: 'entry.1188635855',
        _mkt_trk: 'entry.2038902652',
        HQ_Country__c: 'entry.319595817',
        HQ_State__c: 'entry.479836239',
        Marketing_Channels__c: 'entry.1791059484',
        Email_Sends_per_Month_Range__c: 'entry.1459977454',
        demoRequestNotesImport: 'entry.1805015910',
        demoRequestEmailProvider: 'entry.1758502635',
        Phone: 'entry.966519799',
        Email_Verification_Status__c: 'entry.943228775',
        kickboxReason: 'entry.950835970',
        Locale__c: 'entry.2094900088',
        Primary_Use_Case__c: 'entry.123688354',
        formid: 'entry.1498845011',
        LOG_TYPE: 'entry.256862784',
    };

    const formData = new FormData();
    for (const fieldName in fieldMap) {
        const fieldKey = fieldMap[fieldName];
        formData.append(fieldKey, data[fieldName]);
    }

    try {
        await fetch(
            "https://docs.google.com/forms/u/1/d/e/1FAIpQLSfvgAHZh1i5kIUdyx8wMZ589_4AIt6NVhswontovoogdaQTVQ/formResponse",
            {method: "POST", body: formData}
        );
    } catch (e) {
        // Failsafe
        console.error(e);
    }
}
